import { isWrappingType, isListType, isNonNullType, Kind, GraphQLError, TypeInfo, visit, visitWithTypeInfo, getNamedType, } from 'graphql';
export function safeChangeForField(oldType, newType) {
    if (!isWrappingType(oldType) && !isWrappingType(newType)) {
        return oldType.toString() === newType.toString();
    }
    if (isNonNullType(newType)) {
        const ofType = isNonNullType(oldType) ? oldType.ofType : oldType;
        return safeChangeForField(ofType, newType.ofType);
    }
    if (isListType(oldType)) {
        return ((isListType(newType) &&
            safeChangeForField(oldType.ofType, newType.ofType)) ||
            (isNonNullType(newType) && safeChangeForField(oldType, newType.ofType)));
    }
    return false;
}
export function safeChangeForInputValue(oldType, newType) {
    if (!isWrappingType(oldType) && !isWrappingType(newType)) {
        return oldType.toString() === newType.toString();
    }
    if (isListType(oldType) && isListType(newType)) {
        return safeChangeForInputValue(oldType.ofType, newType.ofType);
    }
    if (isNonNullType(oldType)) {
        const ofType = isNonNullType(newType) ? newType : newType;
        return safeChangeForInputValue(oldType.ofType, ofType);
    }
    return false;
}
export function getKind(type) {
    const node = type.astNode;
    return (node && node.kind) || '';
}
export function getTypePrefix(type) {
    const kind = getKind(type);
    const kindsMap = {
        [Kind.SCALAR_TYPE_DEFINITION]: 'scalar',
        [Kind.OBJECT_TYPE_DEFINITION]: 'type',
        [Kind.INTERFACE_TYPE_DEFINITION]: 'interface',
        [Kind.UNION_TYPE_DEFINITION]: 'union',
        [Kind.ENUM_TYPE_DEFINITION]: 'enum',
        [Kind.INPUT_OBJECT_TYPE_DEFINITION]: 'input',
    };
    return kindsMap[kind];
}
export function isPrimitive(type) {
    return (['String', 'Int', 'Float', 'Boolean', 'ID'].indexOf(typeof type === 'string' ? type : type.name) !== -1);
}
export function isForIntrospection(type) {
    return ([
        '__Schema',
        '__Type',
        '__TypeKind',
        '__Field',
        '__InputValue',
        '__EnumValue',
        '__Directive',
        '__DirectiveLocation',
    ].indexOf(typeof type === 'string' ? type : type.name) !== -1);
}
export function findDeprecatedUsages(schema, ast) {
    const errors = [];
    const typeInfo = new TypeInfo(schema);
    visit(ast, visitWithTypeInfo(typeInfo, {
        Field(node) {
            const fieldDef = typeInfo.getFieldDef();
            if (fieldDef && fieldDef.isDeprecated) {
                const parentType = typeInfo.getParentType();
                if (parentType) {
                    const reason = fieldDef.deprecationReason;
                    errors.push(new GraphQLError(`The field '${parentType.name}.${fieldDef.name}' is deprecated.${reason ? ' ' + reason : ''}`, [node]));
                }
            }
        },
        EnumValue(node) {
            const enumVal = typeInfo.getEnumValue();
            if (enumVal && enumVal.isDeprecated) {
                const type = getNamedType(typeInfo.getInputType());
                if (type) {
                    const reason = enumVal.deprecationReason;
                    errors.push(new GraphQLError(`The enum value '${type.name}.${enumVal.name}' is deprecated.${reason ? ' ' + reason : ''}`, [node]));
                }
            }
        },
    }));
    return errors;
}
export function removeFieldIfDirectives(node, directiveNames) {
    if (node.directives) {
        if (node.directives.some((d) => directiveNames.indexOf(d.name.value) !== -1)) {
            return null;
        }
    }
    return node;
}
export function removeDirectives(node, directiveNames) {
    if (node.directives) {
        return Object.assign(Object.assign({}, node), { directives: node.directives.filter((d) => directiveNames.indexOf(d.name.value) === -1) });
    }
    return node;
}
//# sourceMappingURL=graphql.js.map